import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views')
  },
  {
    path: '/new/:id',
    name: 'New',
    component: () => import('@/views/news')
  }
]

const router = new VueRouter({
  routes
})

export default router
